import './Skeleton.css';

export const SkeletonBone = ({ className = '' }) => <span className={`te-skeleton-bone ${className}`.trim()} aria-hidden="true" />;

const Skeleton = ({ className = '', children, label = 'Loading' }) => (
  <div className={`te-skeleton ${className}`.trim()} role="status" aria-busy="true" aria-label={label} data-testid="skeleton">
    {children}
  </div>
);

export default Skeleton;
